import { SpyneTrait } from "spyne";
import {
  __,
  add,
  compose,
  concat,
  defaultTo,
  equals,
  evolve,
  filter,
  findIndex,
  head,
  join,
  last,
  omit,
  path,
  pick,
  reject,
  slice,
  values,
} from "ramda";
import { UtilTraits } from "./util-traits";

export class BreadcrumbTraits extends SpyneTrait {
  constructor(context) {
    let traitPrefix = "breadcrumb$";

    super(context, traitPrefix);
  }

  static breadcrumb$FormatArrForDocs(arr = []) {
    return compose(reject(equals("pageId")))(arr);
  }

  static breadcrumb$FormatRouteDataForDocs(routeData = {}) {
    return omit(["pageId", "eventPreventDefault"], routeData);
  }

  static breadcrumb$FormatPayloadForDocsPage(payload) {
    const transformations = {
      paths: BreadcrumbTraits.breadcrumb$FormatArrForDocs,
      pathRemoved: BreadcrumbTraits.breadcrumb$FormatArrForDocs,
      pathsAdded: BreadcrumbTraits.breadcrumb$FormatArrForDocs,
      pathsChanged: BreadcrumbTraits.breadcrumb$FormatArrForDocs,
      routeData: BreadcrumbTraits.breadcrumb$FormatRouteDataForDocs,
    };

    return evolve(transformations, payload);
  }

  static breadcrumb$getPathsArrBasedOnPathInnermost(
    pathsInnermost = "",
    breadcrumbsArr = ["pageId", "stage", "section", "topic", "subtopic"],
  ) {
    return compose(
      slice(0, __, breadcrumbsArr),
      add(1),
      findIndex(equals(pathsInnermost)),
    )(breadcrumbsArr);
  }

  static breadcrumb$getLabelsArrByRouteData(levelsArr = [], routeData = {}) {
    return compose(values, pick(levelsArr))(routeData);
  }

  static breadcrumb$getDataByLabelsArr(labelsArr, breadcrumbData = {}) {
    const defaultObj = {
      menuLabel: "Docs",
      menuData: {
        pageId: "docs",
        endRoute: true,
        itemType: "page",
        contentLevel: 1,
      },
    };

    const pred = (data) =>
      UtilTraits.util$ShallowDeepEqArr(labelsArr, data.labelsArrs);
    return compose(defaultTo(defaultObj), head, filter(pred))(breadcrumbData);
  }

  static breadcrumb$CreateUrl(obj) {
    return compose(concat("/"), join("/"), values)(obj);
  }

  static breadcrumb$CreateBreadcrumbData(payload = {}, breadcrumbData = {}) {
    const {
      routeData,
      pathInnermost,
      paths,
      pathsChanged,
      pathsRemoved,
      pathsAdded,
    } = payload;

    const breadcrumbsArr =
      BreadcrumbTraits.breadcrumb$getPathsArrBasedOnPathInnermost(
        pathInnermost,
      );

    const addDocsPageIdToArr = (arr) => arr.unshift("docs");

    const reduceToBreadcrumbDataArr = (acc, str, i) => {
      const arr = breadcrumbsArr.slice(0, i + 1);
      const labelsArr = BreadcrumbTraits.breadcrumb$getLabelsArrByRouteData(
        arr,
        routeData,
      );
      const data = BreadcrumbTraits.breadcrumb$getDataByLabelsArr(
        labelsArr,
        breadcrumbData,
      );
      //console.log("LABELS ARR ",{labelsArr, routeData, breadcrumbData, data})
      const text = data.menuLabel;
      const breadcrumbItemDataset = pick(arr, data.menuData);
      const breadcrumbItemUrl = BreadcrumbTraits.breadcrumb$CreateUrl(
        breadcrumbItemDataset,
      );
      breadcrumbItemDataset["text"] = text;
      breadcrumbItemDataset["breadcrumbItemUrl"] = breadcrumbItemUrl;
      const breadcrumbItemData = {
        breadcrumbItemDataset,
        breadcrumbItemUrl,
        text,
      };

      //console.log("arr labelsarr ",{arr,routeData,labelsArr,data,breadcrumbItemData})
      acc.push({ data, breadcrumbItemData });
      return acc;
    };

    //console.log("breadcrubms arr is ",breadcrumbsArr)

    return breadcrumbsArr.reduce(reduceToBreadcrumbDataArr, []);
  }

  static breadcrumb$GetDocsBreadcrumbData(payload = {}, breadrumbData = {}) {
    const isDocsPage = compose(
      equals("docs"),
      path(["routeData", "pageId"]),
    )(payload);

    if (isDocsPage === false) {
      return {
        breadcrumbData: [],
        lastLevelNum: undefined,
      };
    }

    const breadcrumbData = BreadcrumbTraits.breadcrumb$CreateBreadcrumbData(
      payload,
      breadrumbData,
    );

    const lastLevelNum = compose(
      path(["data", "menuData", "contentLevel"]),
      last,
    )(breadcrumbData);

    return { breadcrumbData, lastLevelNum };
  }

  static breadcrumb$HelloWorld() {
    return "Hello World";
  }
}
